import { type CalendarEvent, EventCalendar as EventCalendarRc } from '@pba/react-components';
import type { ComponentProps } from 'react';

type EventCalendarProperties<T extends CalendarEvent> = ComponentProps<typeof EventCalendarRc<T>>;

const EventCalendar = <T extends CalendarEvent>(props: EventCalendarProperties<T>) => <EventCalendarRc<T> {...props} />;

export default EventCalendar;
